// GlobalAutocomplete.tsx
import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { cn } from "@/lib/utils";

interface GlobalAutocompleteProps<T> {
    label?: string;
    options: T[];
    value: T | null;
    onChange: (newValue: T | null) => void;
    placeholder?: string;
    getOptionLabel: (option: T) => string;
     onInputChange?: (value: string) => void;
}

const GlobalAutocomplete = <T,>({
    label,
    options,
    value,
    onChange,
    placeholder,
    getOptionLabel,
    onInputChange
}: GlobalAutocompleteProps<T>) => {
    return (
        <Autocomplete
            freeSolo   // allows entering custom values
            options={options}
            value={value}
            onChange={(_, newValue) => onChange(newValue as T | null)}
            onInputChange={(_, newValue) => onInputChange?.(newValue)}
            getOptionLabel={(option) => {
                // Handle freeSolo where option can be string
                if (typeof option === "string") return option;
                return getOptionLabel(option as T);
            }}
            isOptionEqualToValue={(option, val) =>
                JSON.stringify(option) === JSON.stringify(val)
            }
            renderInput={(params) => (
                <TextField {...params} placeholder={placeholder} size="small" fullWidth className={cn(
                    "flex h-10 w-full rounded-md border-2  bg-background px-3 py-2 text-base ring-offset-background file:border file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
                )} />
            )}
        />
    );
};

export default GlobalAutocomplete;
